<processing-indicator *ngIf="isProcessing"></processing-indicator>
<div>
  <canvas id="{{canvasId}}"></canvas>
</div>